import React, { useState, useRef, useEffect } from 'react';
import { Image } from '@crystallize/react-image';

function supportsMediaSource() {
  var hasWebKit = ('WebKitMediaSource' in window);
  var hasMediaSource = ('MediaSource' in window);
  return hasWebKit || hasMediaSource;
}

var supportsDash = supportsMediaSource;
var added = false;

function getDash() {
  return new Promise(function (resolve) {
    if (!added) {
      var hlsCore = document.createElement('script');
      hlsCore.src = 'https://cdn.dashjs.org/latest/dash.all.min.js';
      hlsCore.defer = true;
      document.head.appendChild(hlsCore);
      added = true;
    }

    (function checkForLibraryExistence() {
      if ('dashjs' in window) {
        resolve(window.dashjs);
      } else {
        setTimeout(checkForLibraryExistence, 10);
      }
    })();
  });
}

var added$1 = false;

function getHls() {
  return new Promise(function (resolve) {
    if (!added$1) {
      var hlsCore = document.createElement('script');
      hlsCore.src = 'https://cdn.jsdelivr.net/npm/hls.js@latest';
      hlsCore.defer = true;
      document.head.appendChild(hlsCore);
      added$1 = true;
    }

    (function checkForLibraryExistence() {
      if ('Hls' in window) {
        resolve(window.Hls);
      } else {
        setTimeout(checkForLibraryExistence, 10);
      }
    })();
  });
}

var Video = function Video(_ref) {
  var playlists = _ref.playlists,
      thumbnails = _ref.thumbnails,
      thumbnailProps = _ref.thumbnailProps,
      videoProps = _ref.videoProps,
      autoPlay = _ref.autoPlay,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? false : _ref$loop,
      _ref$muted = _ref.muted,
      muted = _ref$muted === void 0 ? false : _ref$muted,
      _ref$controls = _ref.controls,
      controls = _ref$controls === void 0 ? true : _ref$controls,
      className = _ref.className;

  var _useState = useState(true),
      showThumbnail = _useState[0],
      setShowThumbnail = _useState[1];

  var _useState2 = useState(autoPlay),
      playVideo = _useState2[0],
      setPlayVideo = _useState2[1];

  var _useState3 = useState(false),
      initiated = _useState3[0],
      setInitiated = _useState3[1];

  var ref = useRef(null);
  useEffect(function () {
    if (!playVideo) {
      return;
    }

    if (initiated) {
      return;
    }

    var video = ref.current;

    if (!video) {
      throw new Error('Cannot initialize video. Cannot find the video HTML node');
    }

    if (supportsDash()) {
      getDash().then(function (dashjs) {
        var src = playlists.find(function (p) {
          return p.endsWith('.mpd');
        });

        if (!src) {
          throw new Error('Cannot find a valid Dash source for video');
        }

        var player = dashjs.MediaPlayer().create();
        player.initialize();
        player.updateSettings({
          debug: {
            logLevel: dashjs.Debug.LOG_LEVEL_NONE
            /* turns off console logging */

          },
          streaming: {
            scheduleWhilePaused: false
            /* stops the player from loading segments while paused */
            ,
            fastSwitchEnabled: true
            /* enables buffer replacement when switching bitrates for faster switching */

          }
        });
        player.setAutoPlay(true);
        player.attachView(video);
        player.attachSource(src);
        setInitiated(true);
      });
    } else {
      var src = playlists.find(function (p) {
        return p.endsWith('.m3u8');
      });

      if (!src) {
        throw new Error('Cannot find a valid HLS source for video');
      }
      /**
       * iOS has native support for HLS, and we can use
       * the m3u8 source directly, without the use of hls.js
       */


      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.autoplay = true;
        video.src = src; // setTimeout(() => video.play(), 50);

        setInitiated(true);
      } else {
        getHls().then(function (hls) {
          hls.loadSource(src);
          hls.attachMedia(video);
          setInitiated(true);
        });
      }
    }
  }, [playVideo]);
  useEffect(function () {
    if (initiated) {
      var activeEl = document.activeElement;

      if (activeEl) {
        activeEl.blur();
      }

      setShowThumbnail(false);
    }
  }, [initiated]);

  function onPlayClick(event) {
    event.preventDefault();
    setPlayVideo(true);
  }

  var thumbnailStyle = {
    zIndex: showThumbnail ? 2 : 1,
    opacity: !initiated ? 1 : 0
  };
  return React.createElement("div", {
    className: "react-video" + (className ? " " + className : ''),
    style: {
      position: 'relative'
    }
  }, thumbnails && thumbnails.length > 0 ? React.createElement(Image, Object.assign({}, thumbnails[0], {
    className: "react-video__thumbnail"
  }, thumbnailProps, {
    style: thumbnailStyle
  })) : React.createElement("div", {
    className: "react-video__thumbnail-placeholder",
    style: thumbnailStyle
  }), showThumbnail && React.createElement("button", {
    className: "react-video__play-btn",
    onClick: onPlayClick
  }, "PLAY", React.createElement("svg", {
    viewBox: "0 0 100 100",
    className: "react-video__play-icon"
  }, React.createElement("path", {
    d: "M78.158 51.843L25.842 82.048c-1.418.819-3.191-.205-3.191-1.843v-60.41c0-1.638 1.773-2.661 3.191-1.843l52.317 30.205c1.418.819 1.418 2.867-.001 3.686z"
  }))), React.createElement("video", Object.assign({
    className: "react-video__video",
    ref: ref,
    controls: controls,
    playsInline: true,
    muted: muted,
    loop: loop,
    style: {
      opacity: initiated ? 1 : 0,
      zIndex: showThumbnail ? 1 : 2
    }
  }, videoProps)));
};

export { Video };